module.exports = __webpack_public_path__ + "static/img/logo_038.9aaa6dcc.png";